var map = {
	"./1642-protestation": 8,
	"./1642-protestation.jpg": 8,
	"./Distinguished-Flying-Cross": 9,
	"./Distinguished-Flying-Cross copy": 10,
	"./Distinguished-Flying-Cross copy.jpg": 10,
	"./Distinguished-Flying-Cross.jpg": 9,
	"./Endecott-Display-1": 11,
	"./Endecott-Display-1.jpg": 11,
	"./Endecott-coin-1a": 12,
	"./Endecott-coin-1a copy": 13,
	"./Endecott-coin-1a copy.jpg": 13,
	"./Endecott-coin-1a.jpg": 12,
	"./JEFA4-News-Vol-13-No-2-fall-winter-2020": 14,
	"./JEFA4-News-Vol-13-No-2-fall-winter-2020.jpg": 14,
	"./John-pear": 15,
	"./John-pear copy": 16,
	"./John-pear copy.png": 16,
	"./John-pear.png": 15,
	"./Médaille Militaire (Military Medal) ": 17,
	"./Médaille Militaire (Military Medal)  copy": 18,
	"./Médaille Militaire (Military Medal)  copy.jpg": 18,
	"./Médaille Militaire (Military Medal) .jpg": 17,
	"./Washington": 19,
	"./Washington.jpg": 19,
	"./Y-DNA": 20,
	"./Y-DNA.png": 20,
	"./aaa_Endecott_Book_of_Recipes_002": 21,
	"./aaa_Endecott_Book_of_Recipes_002.jpg": 21,
	"./abagail": 22,
	"./abagail-1": 23,
	"./abagail-1.png": 23,
	"./abagail-2": 24,
	"./abagail-2.png": 24,
	"./abagail.png": 22,
	"./abagail_background": 25,
	"./abagail_background.png": 25,
	"./babel.config": 26,
	"./babel.config.jpg": 26,
	"./buriel-1": 27,
	"./buriel-1.png": 27,
	"./buriel-2": 28,
	"./buriel-2.png": 28,
	"./buriel-3": 29,
	"./buriel-3.png": 29,
	"./buriel-4": 30,
	"./buriel-4.png": 30,
	"./buriel-5": 31,
	"./buriel-5.png": 31,
	"./buriel-6": 32,
	"./buriel-6.png": 32,
	"./buriel-7": 33,
	"./buriel-7.png": 33,
	"./buriel-8": 34,
	"./buriel-8.png": 34,
	"./buriel-9": 35,
	"./buriel-9.png": 35,
	"./colonial": 36,
	"./colonial.jpg": 36,
	"./cutting-the-flag": 37,
	"./cutting-the-flag.png": 37,
	"./distinguishedservicecross": 38,
	"./distinguishedservicecross.jpg": 38,
	"./endicott-tree": 39,
	"./endicott-tree.jpg": 39,
	"./endicott_7": 40,
	"./endicott_7.jpg": 40,
	"./endicott_flag": 41,
	"./endicott_flag.jpg": 41,
	"./endicott_pear": 42,
	"./endicott_pear.jpg": 42,
	"./endicott_tree_growth": 43,
	"./endicott_tree_growth.jpg": 43,
	"./flag": 5,
	"./flag copy": 44,
	"./flag copy.svg": 44,
	"./flag.png": 5,
	"./flag.svg": 109,
	"./illustration-0717-2020-john-endicott": 45,
	"./illustration-0717-2020-john-endicott.png": 45,
	"./image_5": 46,
	"./image_5.jpg": 46,
	"./introduction": 47,
	"./introduction.jpg": 47,
	"./john-endecott-coin": 48,
	"./john-endecott-coin.png": 48,
	"./john-pear-sons": 49,
	"./john-pear-sons copy": 50,
	"./john-pear-sons copy.png": 50,
	"./john-pear-sons.png": 49,
	"./john-planting": 51,
	"./john-planting-2": 52,
	"./john-planting-2.png": 52,
	"./john-planting.png": 51,
	"./john-tree": 53,
	"./john-tree.png": 53,
	"./map_mass_bay_colony": 54,
	"./map_mass_bay_colony.jpg": 54,
	"./michelle": 55,
	"./michelle copy": 56,
	"./michelle copy.png": 56,
	"./michelle.png": 55,
	"./middlecot": 57,
	"./middlecot.jpg": 57,
	"./military": 58,
	"./military.jpg": 58,
	"./national-aegis-newspaper-0106-1841-red-cross-endicott": 59,
	"./national-aegis-newspaper-0106-1841-red-cross-endicott-winthrop": 60,
	"./national-aegis-newspaper-0106-1841-red-cross-endicott-winthrop.png": 60,
	"./national-aegis-newspaper-0106-1841-red-cross-endicott.png": 59,
	"./natl-aegis-news1841-red-cross": 61,
	"./natl-aegis-news1841-red-cross.png": 61,
	"./newsletter": 62,
	"./newsletter.png": 62,
	"./page_4": 63,
	"./page_4.jpg": 63,
	"./pear-6": 64,
	"./pear-6.png": 64,
	"./pear-map": 65,
	"./pear-map.png": 65,
	"./pear_1": 66,
	"./pear_1.jpg": 66,
	"./pear_2": 67,
	"./pear_2.jpg": 67,
	"./pear_22": 68,
	"./pear_22.jpg": 68,
	"./pear_3": 69,
	"./pear_3.jpg": 69,
	"./pear_4": 70,
	"./pear_4.jpg": 70,
	"./pear_5": 71,
	"./pear_5.jpg": 71,
	"./pear_6": 72,
	"./pear_6.jpg": 72,
	"./pear_7": 73,
	"./pear_7.jpg": 73,
	"./pear_tree_20": 74,
	"./pear_tree_20.jpg": 74,
	"./peartree_10": 75,
	"./peartree_10.png": 75,
	"./redcross": 76,
	"./redcross.png": 76,
	"./salem_village_1692": 77,
	"./salem_village_1692.jpg": 77,
	"./samuel": 78,
	"./samuel.jpg": 78,
	"./samuelcheck": 79,
	"./samuelcheck.jpg": 79,
	"./statue": 80,
	"./statue.png": 80,
	"./tree-plaque": 81,
	"./tree-plaque.png": 81
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;